<template>
  <div class="minor-protect-page">
    
        <div style="width: 100%; height: 65px; position: fixed; background-color: black;"></div>
    <div class="container">
      <h1 class="title">未成年人保护指引</h1>
      <p class="subtitle">为营造健康、安全、友好的网络环境，中青网为未成年人用户及其监护人提供如下使用指引与保护措施。</p>

      <!-- 使用总则 -->
      <div class="section">
        <h2>一、总则</h2>
        <p>中青网是面向音乐与漫画的综合性平台，倡导积极向上、寓教于乐的创作与消费行为。未成年人在使用平台时，应在监护人监护、指导下合理安排上网时间，避免沉迷网络。</p>
      </div>

      <!-- 监护人指引 -->
      <div class="section">
        <h2>二、监护人监护指引</h2>
        <ol>
          <li>与未成年人共同制定上网计划：明确每日/每周的上网时长与内容范围。</li>
          <li>关注未成年人身心健康：引导其平衡学习、休息与娱乐，鼓励运动、阅读与社交。</li>
          <li>加强沟通与陪伴：与未成年人一起选择适龄、正向的音乐与漫画内容。</li>
          <li>关注平台消息通知：及时了解帐号安全、消费提醒与内容更新等信息。</li>
        </ol>
      </div>

      <!-- 使用时间与功能管理 -->
      <div class="section">
        <h2>三、时间管理与功能限制</h2>
        <ol>
          <li>建议合理安排使用时段与时长，避免影响学习与休息；平台将持续探索“使用时长提醒”等友好功能。</li>
          <li>平台可能对部分互动功能设置适龄限制；未成年人应避免在深夜时段长时间在线。</li>
          <li>如发现沉迷迹象，监护人可协助调整上网计划或暂停使用。</li>
        </ol>
      </div>

      <!-- 内容分级与适龄提示 -->
      <div class="section">
        <h2>四、内容分级与适龄提示</h2>
        <ol>
          <li>平台倡导适龄化创作与发布，对明显不适宜未成年人的内容将予以限制展示、降权或下架处理。</li>
          <li>建议优先选择“教育启蒙、科普益智、艺术鉴赏、健康生活、正向表达”等主题内容。</li>
          <li><strong>未成年人与监护人如对内容适龄性存疑，可通过举报渠道反馈，我们将尽快核查处理。</strong></li>
        </ol>
      </div>

      <!-- 付费与消费提示 -->
      <div class="section">
        <h2>五、付费与消费提示</h2>
        <ol>
          <li>平台提供音乐素材与漫画章节的解锁等服务，涉及虚拟币（硬币）充值与消费。</li>
          <li><strong>未成年人进行充值或消费前，应征得监护人同意；监护人应加强支付工具的保管与授权管理。</strong></li>
          <li>如发生未经授权的消费，请第一时间联系平台客服协助处理。</li>
        </ol>
      </div>

      <!-- 隐私与信息安全 -->
      <div class="section">
        <h2>六、隐私与信息安全</h2>
        <ol>
          <li>平台将依法依规保护未成年人个人信息，尽量减少不必要的信息收集与使用。</li>
          <li>未成年人不应在平台公开发布包含真实姓名、住址、联系方式、学校等敏感信息的内容。</li>
          <li>如发现可疑账号索取个人隐私或财务信息，请立即停止互动并向平台举报。</li>
        </ol>
      </div>

      <!-- 不良行为与举报处置 -->
      <div class="section">
        <h2>七、不良行为与举报</h2>
        <ol>
          <li>禁止欺凌、侮辱、骚扰、诱导不当行为等不良互动；平台将对相关账号采取包括警告、限制、封禁在内的措施。</li>
          <li>发现违法违规或不适宜未成年人内容，请通过页面内的举报入口或联系客服反馈。</li>
          <li>平台对明确违法违规内容将迅速处理，必要时配合有关部门开展工作。</li>
        </ol>
      </div>

      <!-- 心理支持与求助 -->
      <div class="section">
        <h2>八、心理健康与求助</h2>
        <p>如未成年人出现情绪波动、压力过大或遭遇网络欺凌等情况，建议及时求助：</p>
        <ul>
          <li>向监护人、老师或可信赖的成年人沟通。</li>
          <li>拨打心理咨询热线或寻求专业心理咨询机构帮助。</li>
          <li>向平台客服反馈以获得必要的协助与引导。</li>
        </ul>
      </div>

      <!-- 联系方式与响应 -->
      <div class="section">
        <h2>九、联系方式与响应机制</h2>
        <ul>
          <li>客服邮箱：zqwzbs@126.com</li>
          <li>客服工作时间：每日 9:00-22:00（法定节假日照常）</li>
          <li>紧急问题请在邮件主题中标注“未成年人保护-紧急”。</li>
        </ul>
        <p>我们将尽力在合理时限内响应并处理您的反馈。</p>
      </div>

      <div class="card foot">
        <p>说明：本指引将根据法律法规与业务变化适时更新，请您与监护人共同关注平台公告。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MinorProtect',
}
</script>

<style scoped lang="scss">
.minor-protect-page { background:#fff; color:#0f172a; }
.container { max-width: 900px; margin: 0 auto; padding: 92px 16px 60px; }
.title { margin:0; font-size: 28px; font-weight: 800; letter-spacing: -.3px; }
.subtitle { margin: 8px 0 16px; color:#64748b; line-height: 1.6; }

.section { background:#fff; border:1px solid #e2e8f0; border-radius: 12px; padding: 14px; margin-bottom: 14px; }
.section h2 { margin:0 0 10px; font-size: 16px; font-weight: 800; color:#0f172a; }
.section p { margin: 8px 0; color:#334155; line-height: 1.75; }
.section ol, .section ul { margin: 8px 0 0 18px; color:#334155; line-height: 1.75; }
.section li { padding-left: 4px; }

.card.foot { background:#f8fafc; border:1px solid #e2e8f0; border-radius: 12px; padding: 14px; }

@media (max-width: 520px) {
  .container { padding: 88px 12px 40px; }
  .title { font-size: 22px; }
}
</style>
